<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Create Call Log'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="getPrimaryLabel"
        :secondaryLabel="getSecondaryLabel"
        v-if="loaded"
      />
    </template>

    <div class="create-surveys css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="model"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="header-form-container">
        <div class="header-form-1">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="model"
              :formContentReady="formContentReady"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :valueChangeCallBack="headerFormValueChanged"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formHeight="130"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="notes-container" v-if="NumOfQuestions.length > 0">
        <div class="heading">
          <span> <h4>Questions</h4></span>
        </div>
        <hr />

        <!-- <DxScrollView
          id="scrollview"
          :direction="'horizontal'"
          :scroll-by-content="true"
          :scroll-by-thumb="true"
          :show-scrollbar="'always'"
          :height="200"
        > -->
        <div
          class="notes"
          v-bind:style="{
            'max-height': scrollViewHeight + 'px',
          }"
        >
          <div
            class="note"
            v-for="(item, index) in NumOfQuestions"
            v-bind:key="index"
          >
            <div>
              <div class="toolbar">
                <div class="question-section">
                  <div
                    class="display-question"
                    v-bind:style="{
                      width: isTablet
                        ? 'calc(100% - 120px)'
                        : 'calc(100% - 100px)',
                    }"
                  >
                    <!-- width: calc(100% - 100px); -->
                    <span>{{ item.Question }}</span>
                  </div>
                  <div class="display-answers">
                    <DxRadioGroup
                      :items="[
                        {
                          text: 'Yes',
                          value: 'Y',
                        },
                        {
                          text: 'No',
                          value: 'N',
                        },
                      ]"
                      valueExpr="value"
                      :displayExpr="'text'"
                      :value="item.Answer"
                      @value-changed="
                        onRadioValueChange(
                          $event,
                          item,
                          'note-validation-' + index
                        )
                      "
                      :elementAttr="{ class: 'gc-field-radio-wrapper' }"
                      :disabled="baseView.mode == 'review'"
                    />
                  </div>
                </div>
                <br />
                <div class="note-details">
                  <form style="width: 100%">
                    <DxForm
                      :show-colon-after-label="false"
                      :show-required-mark="false"
                      :show-validation-summary="false"
                      :form-data="item"
                      :width="'100%'"
                      :items="getNoteFormItems(item)"
                      @content-ready="
                        onNoteFormContentReady(
                          $event,
                          'note-validation-' + index
                        )
                      "
                      :validation-group="'note-validation-' + index"
                      :ref="'note-validation-' + index"
                    ></DxForm>
                  </form>
                </div>
                <div class="notes-content">
                  <div class="uploader">
                    <DxFileUploader
                      select-button-text="Upload"
                      label-text=""
                      accept="image/*"
                      upload-mode="useForm"
                      :show-file-list="false"
                      :multiple="true"
                      @value-changed="onImageUploaded($event, item)"
                      :visible="baseView.mode != 'review'"
                      :width="85"
                    />

                    <span
                      class="img-required"
                      v-if="
                        item &&
                          item.ImageRequired == 'Y' &&
                          item.imageSrcs &&
                          item.imageSrcs.length == 0 &&
                          baseView.mode != 'review'
                      "
                      >Image Required</span
                    >
                  </div>
                </div>

                <!-- <div>
                  {{ item.imageSrcs.length }}
                </div> -->
                <div
                  class="thumbnail-container"
                  v-if="item.imageSrcs.length > 0"
                >
                  <img
                    v-for="(img, x) in item.imageSrcs"
                    v-bind:key="x"
                    :src="img.src"
                    alt="Company Logo"
                    height="200"
                    width="200"
                    @click="previewThumbnail(img, item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </DxScrollView> -->

        <GcPopupImagePreview
          :previewVisible="previewVisible"
          :onBackButtonClick="() => (previewVisible = false)"
          :dataModel="imgDataModel"
          :allow-download="baseView.mode != 'create'"
          :allow-remove="baseView.mode != 'review'"
          :onRemoveImage="onRemoveImage"
        />
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import validationEngine from "devextreme/ui/validation_engine";

import { CustomerService } from "../../_services/api/customers/customer.service";
import { SurveyTemplateService } from "../../_services/api/settings/sales/survey-template.service";
import { CustomerSurveysResponseService } from "../../_services/api/customers/customer-surveys-response.service";
import { FeatureStorage } from "../../_services/storage";
import resizeImage from "../../_helpers/image-processing/resizeImage";
import appConfig from "../../app-config";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {},
  data() {
    return {
      loaded: false,
      previewVisible: false,
      isValid: false,
      model: {
        Status: undefined,
        CustomerCode: undefined,
        StartDate: new Date(),
        EndDate: undefined,
        Description: undefined,
        SurveyTemplateRecordId: undefined,
        SurveyTempRecordId: undefined,
      },
      NumOfQuestions: [],
      previewImg: undefined,
      imgDataModel: {},
      customerName: "",
      backButtonRoute: "/call-schedule-surveys",
      scrollViewHeight: undefined,
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},
  computed: {
    getPrimaryLabel() {
      if (this.baseView.mode == "create") return `Create Survey Response`;
      else {
        return "Survey Response for";
      }
    },
    getSecondaryLabel() {
      if (this.baseView.mode == "create") return undefined;
      else {
        return this.customerName;
      }
    },
    getHeaderToolbar() {
      return {
        audit: true,
        status: true,
        notes: false,
        save:
          this.model.Status != "C" &&
          FeatureStorage.checkPermission("SurveyResponse", "create"),
        editURL: "/surveys",
        // editCallBack: this.editSOCallBack,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
      };
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField: "Customer",
                  dataField: "CustomerCode",
                  required: true,
                  editorOptions: {
                    allowUpdate: false,
                    tabIndex: 1,
                    // onValueChanged: this.onDateInValueChanged.bind(this),
                  },
                },
                {
                  screenField: "CustomerSurveyTemplate",
                  dataField: "SurveyTempRecordId",
                  editorOptions: {
                    allowUpdate: false,
                    readOnly: !this.model.CustomerCode,
                    onItemClick: this.onCustomerSurveyTemplateSelected,
                    keyType: {
                      RecordIdString: "String",
                    },
                  },
                  filter: [
                    ["CustomerCode", "=", this.model.CustomerCode],
                    "and",
                    [["Status", "<>", "X"], "and", ["Status", "<>", "C"]],
                  ],
                  required: true,
                  valueExpr: "RecordIdString",
                  displayExpr: "SurveyName",
                  formField: {
                    label: "Survey Template",
                    dataField: "RecordIdString",
                  },
                  editorTemplate: {
                    primary: [
                      {
                        dataField: "SurveyName",
                      },
                    ],
                  },
                },
                {
                  label: {
                    text: "Start Date",
                  },
                  dataField: "StartDate",
                  required: true,
                  editorType: "dxDateBox",
                  // cssClass: "start-call-date",
                  touchEnabled: true,
                  editorOptions: {
                    showAnalogClock: true,
                    pickerType: "calendar",
                    step: 1,
                    tabIndex: 3,
                    type: "date",
                    displayFormat: "dd MMM yyyy",
                    calendarOptions: {
                      step: 1,
                    },
                  },
                },
                {
                  label: {
                    text: "End Date",
                  },
                  touchEnabled: true,
                  dataField: "EndDate",
                  // required: true,
                  editorType: "dxDateBox",
                  // cssClass: "start-call-date",
                  editorOptions: {
                    allowUpdate: false,
                    showAnalogClock: true,
                    pickerType: "calendar",
                    tabIndex: 3,
                    type: "date",
                    displayFormat: "dd MMM yyyy",
                    min: this.model.StartDate,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              colCount: 1,
              colSpan: 2,
              items: [
                {
                  label: {
                    text: "Description",
                  },
                  dataField: "Description",
                  editorType: "dxTextArea",
                  cssClass: "DescriptionField",
                  disabled: true,
                  allowUpdate: false,
                  editorOptions: {
                    tabIndex: -1,
                    height: 100,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
  methods: {
    onNoteFormContentReady(e, group) {
      if (e) validationEngine.validateGroup(group);
    },
    getNoteFormItems(item) {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              editorType: "dxTextArea",
              dataField: "Note",
              label: {
                text: "Note",
              },
              editorOptions: {
                height: 50,
                width: "100%",
                value: item.Note,
                onValueChanged: (e) => {
                  this.onNoteValueChanged(e, item);
                },
                readOnly: this.baseView.mode == "review",
              },
              disabled: this.baseView.mode == "review",
              validationRules:
                item.NoteRequired == "Y" && item.Answer == "N"
                  ? [
                      {
                        type: "required",
                        message: `Note is required`,
                      },
                    ]
                  : [],
            },
          ],
        },
      ];
    },
    onRadioValueChange(e, item, formRef) {
      item.Answer = e.value;
      var form = this.$refs[`${formRef}`];
      if (form) form[0].instance.option("items", this.getNoteFormItems(item));
    },
    async onCustomerSurveyTemplateSelected(e) {
      this.NumOfQuestions = [];
      // this.model.SurveyTempRecordId = e.itemData.RecordId;
      this.model.SurveyTemplateRecordId = `${e.itemData.SurveyTemplateRecordID}`;
      this.model.Description = e.itemData.Description;
      this.showLoading(true);
      await SurveyTemplateService.getQuestionsBySurveyTemplateId(
        e.itemData.SurveyTemplateRecordID
      )
        .then((res) => {
          res.data.value.forEach((element) => {
            element.Answer = undefined;
            element.imageSrcs = [];
            element.Note = undefined;
          });
          this.showLoading(false);

          this.NumOfQuestions = res.data.value;

          this.NumOfQuestions.forEach((element) => {
            element.RecordId = "00000000-0000-0000-0000-000000000000";
          });
        })
        .catch(() => {
          this.showLoading(false);
        });
    },
    formContentReady(e) {
      if (e && this.baseView.mode == "create" && !this.model.CustomerCode) {
        let customerCodeEditor = e.component
          .instance()
          .getEditor("CustomerCode");
        if (!customerCodeEditor.option("value")) {
          customerCodeEditor.focus();
        }
      }
    },
    onRemoveImage(id) {
      this.NumOfQuestions.forEach((element) => {
        element.imageSrcs.forEach((image, index) => {
          if (image.id == id) {
            element.imageSrcs.splice(index, 1);
            return;
          }
        });
      });
    },
    previewThumbnail(img, item) {
      if (img.type != "upload") {
        this.previewImg = item.images.find(
          (x) => x.FileName == img.FileName && x.SizeType == "preview"
        );

        let originalImg = item.images.find(
          (x) => x.FileName == img.FileName && x.SizeType == "original"
        );

        this.imgDataModel = {
          PreviewImageSrc: this.previewImg.ImageUrl,
          OriginalImageBlobName: this.previewImg.BlobName,
          DownloadApiUrl: `${appConfig.VUE_APP_ROOT_API}/api/SurveyResponseImage/${originalImg.BlobName}/download`,
          id: img.id,
        };
      } else {
        this.imgDataModel = {
          PreviewImageSrc: img.src,
          OriginalImageBlobName: undefined,
          id: img.id,
        };
      }

      this.previewVisible = true;
    },
    async onImageUploaded(e, item) {
      if (e.value.length > 0) {
        e.value.forEach(async (element, index) => {
          let img = new Image();
          img.src = window.URL.createObjectURL(element);
          img.onload = async () => {
            var reader = new FileReader();

            // eslint-disable-next-line no-unused-vars
            reader.onload = async function(onloadEvent) {
              let resizedImageStr = resizeImage(img, element.type);

              item.imageSrcs.push({
                src: resizedImageStr,
                type: "upload",
                FileName: element.name,
                ContentType: element.type,
                FileSize: resizedImageStr.length,
                id: element.name + "_" + index,
              });
            };
            await reader.readAsDataURL(element);
          };
        });
      }
    },
    onNoteValueChanged(e, item) {
      item.Note = e.value;
    },
    onStartCallValueChanged() {
      if (new Date(this.model.StartCall) > new Date(this.model.EndCall)) {
        this.model.EndCall = undefined;
        this.Duration = "0 Mins";
      }

      this.updateCallDuration();
    },
    updateCallDuration() {
      if (!this.model.StartCall || !this.model.EndCall) return;

      if (
        this.model.StartCall.toSaveDateObject() >
        this.model.EndCall.toSaveDateObject()
      ) {
        this.displayValidationErrors(["End date cannot be before Start date."]);

        this.model.EndCall = undefined;
        this.model.Duration = "0 Mins";
        return;
      }

      if (this.model.StartCall > this.model.EndCall) {
        this.model.Duration = "0 Mins";
        return;
      }

      var diff =
        (new Date(this.model.EndCall).getTime() -
          new Date(this.model.StartCall).getTime()) /
        1000;
      diff /= 60;
      var minutes = Math.round(diff);

      this.model.Duration = minutes + " Mins";
      this.model.ExpectedDuration = minutes;
    },
    async checkHeaderFormValidation() {
      if (this.model.StartCall > this.model.EndCall) {
        this.displayValidationErrors([
          "End date and time cannot be before Start date and time.",
        ]);
        return;
      }

      let headerform = await validationEngine.validateGroup("gc-header-form");

      var answeredQuestions = this.NumOfQuestions.filter((x) => x.Answer);

      if (headerform.isValid && answeredQuestions.length == 0)
        this.saveSurveyResponse();
      else if (!headerform.isValid && answeredQuestions.length == 0) {
        this.displayValidationSummary(headerform.brokenRules);
      } else {
        var checkRequiredNotes = false;
        var checkRequireImages = false;
        var errors = [];
        if (answeredQuestions.length > 0) {
          checkRequiredNotes = answeredQuestions.find(
            (x) => x.NoteRequired == "Y" && x.Answer == "N" && !x.Note
          );
          checkRequireImages = answeredQuestions.find(
            (x) => x.ImageRequired == "Y" && x.Answer && x.imageSrcs.length == 0
          );
        }

        if (checkRequiredNotes) {
          errors.push({
            message:
              "One or more questions you have answered No to require a note. Please review your notes prior to attempting to save.",
          });
        }

        if (checkRequireImages) {
          errors.push({
            message:
              "One or more questions you have answered require images. Please review your images prior to attempting to save.",
          });
        }

        if (errors.length > 0)
          headerform.brokenRules = headerform.brokenRules.concat(errors);

        if (headerform.brokenRules.length > 0) {
          this.displayValidationSummary(headerform.brokenRules);
        } else {
          this.saveSurveyResponse();
        }
      }
    },
    async saveSurveyResponse() {
      var payload = {
        CustomerCode: this.model.CustomerCode,
        Status:
          this.NumOfQuestions.length ==
          this.NumOfQuestions.filter((x) => x.Answer == "Y").length
            ? "C"
            : "A",
        EndDate: this.model.EndDate
          ? this.model.EndDate
          : this.NumOfQuestions.length ==
            this.NumOfQuestions.filter((x) => x.Answer == "Y").length
          ? new Date()
          : null,
        SurveyTemplateRecordId: this.model.SurveyTemplateRecordId,
        RecordId: this.baseView.id
          ? this.baseView.id
          : "00000000-0000-0000-0000-000000000000",
        StartDate: this.model.StartDate,
        Description: this.model.Description,
        SurveyResponseQuestions: [],
      };

      this.NumOfQuestions.forEach((element) => {
        var imgData = [];
        element.imageSrcs.forEach((img) => {
          imgData.push({
            SurveyResponseQuestionRecordID: element.RecordId,
            // BlobName: "581064f2-32b4-41a3-9a78-991c1ae26fd4_preview.png",
            ContainerName: "images",
            ContentType: img.ContentType,
            FileName: img.name ? img.name : img.FileName,
            FileSize: img.size,
            // ImageUrl:
            //   "https://grorpdevfilestore.blob.core.windows.net/images/581064f2-32b4-41a3-9a78-991c1ae26fd4_preview.png",
            ImageBase64String: img.src,
            // SizeType: "preview",
            RecordId: img.RecordId
              ? img.RecordId
              : "00000000-0000-0000-0000-000000000000",
          });
        });

        payload.SurveyResponseQuestions.push({
          Answer: element.Answer,
          Question: element.Question,
          RecordId: element.RecordId,
          Sequence: element.Sequence,
          SurveyTemplateQuestionRecordID:
            element.SurveyTemplateQuestionRecordID,
          SurveyResponseRecordID: this.baseView.id
            ? this.baseView.id
            : "00000000-0000-0000-0000-000000000000",
          SurveyResponseQuestionNote: {
            Note: element.Note,
            RecordId: "00000000-0000-0000-0000-000000000000",
            SurveyResponseQuestionRecordID: element.RecordId,
          },
          SurveyResponseQuestionImagesMetas: imgData,
        });
      });

      this.showLoading(true);
      await CustomerSurveysResponseService.saveCustomerSurveyResponse(payload)
        .then((res) => {
          this.showLoading(false);
          // eslint-disable-next-line
          console.log("saveCustomerSurveyResponse ", res);

          if (res.data) {
            this.setIgnoreRouteChangeConfirmation();
            this.loaded = false;
            this.$router
              .push({
                path: "/surveys/review/" + res.data.RecordId,
              })
              .then(() => {
                this.initialized();
              });
          }
        })
        .catch((error) => {
          this.showLoading(false);

          this.displayServerError(error, "Save Failed");
        });
    },
    headerFormValueChanged(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
    },
    backButtonFunction() {
      const { from: parentPage } = this.baseView.query;
      let targetPath = "/surveys";

      if (parentPage == "customer-surveys") {
        targetPath = `/customer-surveys/${this.baseView.query.cus_id}`;
      } else if (parentPage) {
        targetPath = `/${parentPage}`;
      }

      this.$router.push({
        path: targetPath,
      });
    },

    async initialized() {
      this.NumOfQuestions = [];
      if (this.baseView.mode != "create") {
        this.showLoading(true);

        try {
          let res = await CustomerSurveysResponseService.getBySurveyResponse(
            this.baseView.id
          );

          if (res.data.value) {
            var surveysResponse = res.data.value[0];
            this.model.Status = surveysResponse.Status;
            // this.model.Status = callLog.Status;
            this.model.CustomerCode = surveysResponse.CustomerCode;
            this.model.SurveyTemplateRecordId =
              surveysResponse.SurveyTemplateRecordID;
            if (surveysResponse.StartDate)
              this.model.StartDate = new Date(surveysResponse.StartDate);

            if (surveysResponse.EndDate)
              this.model.EndDate = new Date(surveysResponse.EndDate);
            this.model.Description = surveysResponse.Description;

            this.model.DateCreated = surveysResponse.DateCreated;
            this.model.DateChanged = surveysResponse.DateChanged;
            this.model.CreatedBy = surveysResponse.CreatedBy;
            this.model.ChangedBy = surveysResponse.ChangedBy;

            let customerSurveyResponse = await CustomerSurveysResponseService.getCustomerSurveyTemplateByRecordId(
              surveysResponse.SurveyTemplateRecordID,
              surveysResponse.CustomerCode
            );
            if (customerSurveyResponse.data.value.length > 0)
              this.model.SurveyTempRecordId = `${customerSurveyResponse.data.value[0].RecordIdString}`;

            let customerResponse = await CustomerService.getByCode(
              this.model.CustomerCode,
              ["Code", "Name"]
            );

            if (customerResponse.data.value.length > 0) {
              this.customerName = customerResponse.data.value[0].Name;
            }

            // this.NumOfQuestions = [];
            let question = await CustomerSurveysResponseService.getSurveyResponseQuestion(
              this.baseView.id
            );

            // this.NumOfQuestions = question.data.value;
            question.data.value.forEach(async (element) => {
              let imagesMeta = await CustomerSurveysResponseService.getSurveyResponseQuestionImagesMeta(
                element.RecordId
              );

              if (imagesMeta.data.value.length > 0) {
                var imgs = [];
                imagesMeta.data.value.forEach((img, index) => {
                  if (
                    img.SizeType == "thumb" &&
                    img.SurveyResponseQuestionRecordID == element.RecordId
                  )
                    imgs.push({
                      src: img.ImageUrl,
                      ContentType: img.ContentType,
                      FileName: img.FileName,
                      RecordId: img.RecordId,
                      id: img.FileName + "_" + index,
                    });
                });
                element.imageSrcs = imgs;
                element.images = imagesMeta.data.value;
              } else {
                element.imageSrcs = [];
              }

              let questionNote = await CustomerSurveysResponseService.getSurveyResponseQuestionNote(
                element.RecordId
              );

              this.showLoading(false);
              if (questionNote.data.value.length > 0)
                element.Note = questionNote.data.value[0].Note;
              this.NumOfQuestions.push(element);
              this.loaded = true;
            });
          }
        } catch (error) {
          this.showLoading(false);
          this.displayServerError(error, "Load Failed");
        }

        this.showLoading(false);
        this.loaded = true;
      } else {
        // this.NumOfQuestions.push({
        //   Note: undefined,
        //   imageSrcs: [],
        // });

        this.model.Status = "D";

        if (this.baseView.query) {
          if (this.baseView.query.cus_id)
            this.model.CustomerCode = this.baseView.query.cus_id;
          if (this.baseView.query.from)
            this.backButtonRoute = this.baseView.query.from;
        }

        this.loaded = true;
      }
    },
  },
  // watch: {
  //   loaded(val) {
  //     if (val) {
  //       console.log("+++++++++++++++++");
  //       setTimeout(() => {
  //         var scrollableView = document.getElementsByClassName(
  //           "layout-body dx-scrollview"
  //         );
  //         this.scrollViewHeight = scrollableView[0].clientHeight - 235 - 70;
  //       }, 250);
  //     }
  //   },
  // },
};
</script>

<style lang="scss">
.create-surveys {
  height: 100%;
  .header-form-container {
    padding-bottom: 10px;

    .DescriptionField {
      > label {
        padding-top: 6px;
      }

      textarea {
        padding-top: 1px !important;
      }
    }

    .start-call-group {
      .start-call-date {
        padding-right: 0px !important;
      }
    }
    .end-call-group {
      .end-call-date {
        padding-right: 0px !important;
      }
    }
  }
  .notes-container {
    background-color: white;

    .heading {
      height: 45px !important;
    }

    hr {
      margin: 0 !important;
    }
    > div:first-child {
      padding: 10px;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    h4 {
      margin: 0 !important;
    }

    .notes {
      overflow-y: auto;
    }

    .note {
      padding: 10px;

      .uploader {
        .dx-fileuploader-wrapper {
          padding: 0 !important;
        }
        .dx-widget.dx-fileuploader {
          height: 100%;
          .dx-fileuploader-input-wrapper {
            height: 100%;
            border: 0px dashed transparent;
            .dx-fileuploader-input-container {
              input {
                padding: 0 !important;
              }
            }
          }
        }
        .dx-button {
          border-radius: 4px;
          background-color: #03a9f4 !important;
          color: #fff;
          display: flex;
          flex-direction: column;
          z-index: 100;
        }
      }

      > div {
        border-style: solid;
        border-color: #e8e8ed;
        border-width: 2px;
        width: 100%;
        padding: 10px;
        border-radius: 2px;
      }

      .toolbar {
        display: inline-flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
        width: 100%;

        > span:first-child {
          padding-top: 4px;
        }

        .notes-text {
          margin-left: 10px;
          textarea {
            padding-top: 0px !important;
          }
        }

        .question-section {
          display: inline-flex;
          width: 100%;
          justify-content: space-between;

          .display-question {
            padding-right: 10px;
            padding-top: 6px;

            > span {
              word-wrap: break-word;
              display: block;
            }
          }

          .dx-radiogroup {
            .dx-widget.dx-collection {
              display: inline-flex;

              > div:first-child {
                padding-right: 10px;
              }
            }
          }
        }

        .note-details {
          display: inline-flex;
          width: 100%;
        }

        .notes-content {
          display: inline-flex;
          flex-direction: row;
          width: 100%;
          align-items: flex-end;

          .uploader {
            display: inline-flex;
            align-items: flex-end;

            .img-required {
              padding-left: 10px;
              color: #f44336;
            }
          }
        }
      }

      .thumbnail-container {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 8px;

        img {
          margin-right: 10px !important;
          margin-bottom: 10px !important;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
